import { PlatformConfiguration } from '../model';

export const configuration: PlatformConfiguration = {
  button: {
    background: 'gradient',
    type: 'primary',
  },
  input: {
    label: 'inline',
    height: '48px',
  },
  amountInput: {
    variant: 'outlined',
  },
  errors: {
    position: 'top',
    type: 'default',
  },
  balance: {
    visible: false,
  },
};
